"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapAttachment = exports.SnapMediaType = exports.Type = exports.WWWStoryType = exports.ExitEvents = void 0;
var ExitEvents;
(function (ExitEvents) {
    ExitEvents["TAP"] = "TAP";
    ExitEvents["AUTO_ADVANCE"] = "AUTO_ADVANCE";
    ExitEvents["PAUSE"] = "PAUSE";
})(ExitEvents = exports.ExitEvents || (exports.ExitEvents = {}));
// these are story type enums used in content-platform/www
var WWWStoryType;
(function (WWWStoryType) {
    WWWStoryType["DYNAMIC"] = "TYPE_DYNAMIC";
    WWWStoryType["PUBLIC_USER"] = "TYPE_PUBLIC_USER_STORY";
    WWWStoryType["MAPS"] = "TYPE_MAPS";
    WWWStoryType["PUBLISHER"] = "TYPE_PUBLISHER_STORY";
    WWWStoryType["SPOTLIGHT"] = "TYPE_COMMUNITY";
})(WWWStoryType = exports.WWWStoryType || (exports.WWWStoryType = {}));
var Type;
(function (Type) {
    Type["Community"] = "COMMUNITY";
    /**
     * @deprecated - This is deprecated
     */
    Type["Discover"] = "DISCOVER";
    Type["Dynamic"] = "DYNAMIC";
    Type["Featured"] = "FEATURED";
    Type["LensStory"] = "LENS_STORY";
    Type["LiveStream"] = "LIVE_STREAM";
    Type["Maps"] = "MAPS";
    Type["MapsSingleSnap"] = "MAPS_SINGLE_SNAP";
    Type["PublicMyStorySnap"] = "PUBLIC_MY_STORY_SNAP";
    Type["PublicUserSnap"] = "PUBLIC_USER_SNAP";
    Type["PublicUserStory"] = "PUBLIC_USER_STORY";
    Type["SharedOurStorySnap"] = "SHARED_OUR_STORY_SNAP";
    Type["SharedSingleSnap"] = "SHARED_SINGLE_SNAP";
    Type["StoryFeed"] = "STORY_FEED";
    Type["StoryId"] = "STORY_ID";
    Type["Publisher"] = "PUBLISHER";
    Type["Show"] = "SHOW";
    Type["Unknown"] = "UNKNOWN";
})(Type = exports.Type || (exports.Type = {}));
var SnapMediaType;
(function (SnapMediaType) {
    SnapMediaType["Image"] = "IMAGE";
    SnapMediaType["Unknown"] = "UNKNOWN";
    SnapMediaType["Video"] = "VIDEO";
    SnapMediaType["VideoNoSound"] = "VIDEO_NO_SOUND";
})(SnapMediaType = exports.SnapMediaType || (exports.SnapMediaType = {}));
var SnapAttachment;
(function (SnapAttachment) {
    SnapAttachment["WEB_PAGE"] = "WEB_PAGE";
    SnapAttachment["LONGFORM_VIDEO"] = "LONGFORM_VIDEO";
})(SnapAttachment = exports.SnapAttachment || (exports.SnapAttachment = {}));
//# sourceMappingURL=constants.js.map